import { store } from "@/store/store";

export class Helpers {
  /**
   * @param code{string} => "(D)2"..."(D)14" | "(C)2"..."(C)14" | "(H)2"..."(H)14" | "(S)2"..."(S)14"
   * @return {number}
   */
  static getCardsFrameByCode(code) {
    const suit = code[1];
    const rank = +code.slice(3, code.length);
    let spriteSheetRow = 0;
    switch (suit) {
      case "D": {
        spriteSheetRow = 0;
        break;
      }
      case "H": {
        spriteSheetRow = 1;
        break;
      }
      case "S": {
        spriteSheetRow = 2;
        break;
      }
      case "C": {
        spriteSheetRow = 3;
        break;
      }
    }
    return 13 * spriteSheetRow + rank - 2;
  }
  static getCardsSpriteSheet() {
    return store.getters.getCardsColour === "SIMPLE"
      ? "classic-deck"
      : "four-color-deck";
  }
}
